import {createSlice} from '@reduxjs/toolkit';
import {storage} from '@app/utils/helpers';

const initialState = {
  loading: false,
  isLoggedIn: !!storage.getItem('token', 'session'),
  token: storage.getItem('token', 'session'),
  currentUser: storage.getItem('currUser', 'session') || {},
  error: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, {payload}) => {
      const {user, token} = payload;
      state.loading = false;
      state.isLoggedIn = true;
      state.token = token;
      state.currentUser = user;
      storage.setItem('token', token, 'session');
      storage.setItem('currUser', user, 'session');
    },
    loginError: (state, {payload}) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.token = null;
      state.currentUser = {};
      state.error = payload;
      storage.removeItem('token', 'session');
      storage.removeItem('currUser', 'session');
    },
    logoutUser: (state) => {
      state.loading = false;
      state.currentUser = {};
      state.isLoggedIn = false;
      state.token = null;
      state.error = null;
      storage.removeItem('token', 'session');
      storage.removeItem('currUser', 'session');
    },
    loadUserRequest: (state) => {
      state.loading = true;
    },
    loadUserSuccess: (state, {payload}) => {
      const {user, token} = payload;
      state.loading = false;
      state.isLoggedIn = true;
      state.token = token;
      state.currentUser = user;
      storage.setItem('token', token, 'session');
      storage.setItem('currUser', user, 'session');
    },
    loadUserError: (state) => {
      state.loading = false;
      state.currentUser = {};
      state.isLoggedIn = false;
      state.token = null;
      state.error = null;
      storage.removeItem('token', 'session');
      storage.removeItem('currUser', 'session');
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginError,
  logoutUser,
  loadUserRequest,
  loadUserSuccess,
  loadUserError,
} = authSlice.actions;

export default authSlice.reducer;
